'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _UndoOutlined = _interopRequireDefault(require('./lib/icons/UndoOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _UndoOutlined;
exports.default = _default;
module.exports = _default;